let currentVariant
let isMultipleOptions = false
if (document.querySelector(".variants__select")) {
    isMultipleOptions = document.querySelector(".variants__select").dataset.isMultipleOptions === 'true'
}

//********* Social buttons *********//
const socialButton = document.querySelector(".social-button")
const socialList = document.querySelector(".social-list")

const buyNowQuantity = document.querySelector("#buy-now-quantity")
const buyNowId = document.querySelector("#buy-now-id")
const addToCart = document.querySelector("#add-to-cart")
const buyNow = document.querySelector(".buy-now")
const vipPoints = document.querySelector("#gs-vip-product-points");

const showSocialList = function () {
    if (socialList.classList.contains("hide")) {
        socialList.classList.remove("hide")
        // document.addEventListener("click", showSocialList)
    } else {
        socialList.classList.add("hide")
        // document.removeEventListener("click", showSocialList)
    }
}

if (socialButton) {
    socialButton.addEventListener("click", showSocialList)
}

//*********/ Social buttons *********//

//********* Toggle the state of the buy buttons *********//

const toggleStateButtons = function (state) {

    if (state) {
        addToCart.removeAttribute('disabled')
        buyNow.removeAttribute('disabled')
    } else {
        addToCart.setAttribute('disabled', true)
        buyNow.setAttribute('disabled', true)
    }
}

//*********/ Toggle the state of the buy buttons *********//

//********* Product quantity *********//

const productQuantityBlock = document.querySelector(".product-quantity__block")
const productQuantityMinus = productQuantityBlock?.querySelector(".product-quantity__minus")
const productQuantityPlus = productQuantityBlock?.querySelector(".product-quantity__plus")
const productQuantityValue = productQuantityBlock?.querySelector(".product-quantity__value")

const changeQuantity = function (pointer, step) {
    if (pointer.closest(".product-quantity__minus") && productQuantityValue.value != step) {
        productQuantityValue.value = Number(productQuantityValue.value) - Number(step)
    } else if (pointer.closest(".product-quantity__plus")) {
        productQuantityValue.value = Number(productQuantityValue.value) + Number(step)
    }
    addToCart.dataset.productQuantity = productQuantityValue.value
    buyNow.dataset.productQuantity = productQuantityValue.value
}

productQuantityBlock?.addEventListener("click", function (evt) {
    const pointer = evt.target
    changeQuantity(pointer, productQuantityValue.step)
})

//*********/ Product quantity *********//


//********* NiceSelect *********//
let relatedAddedPrice = 0
let relatedAddedVariant = 0
let isRelatedVariant = false

if (document.getElementById("select-opt-mattress")) {
    isRelatedVariant = true
}

const buildRelatedNiceSelect = () => {
    let niceSelectUl = document.querySelector(".nice-select.multiple-variants__select.select-opt-mattress").querySelector("ul").querySelectorAll("li")
    for (let li of niceSelectUl) {
        let val = li.dataset.value
        if (val !== 'empty-mattress') {
            let text = li.innerText
            let related = document.querySelector(`[data-mattress-id="${val}"]`)
            let price = new Intl.NumberFormat('it-IT', {maximumFractionDigits: 2}).format(related.dataset.price / 100)

            li.innerHTML = `<div class="nice-mattress-dropdown-row"><a class="nice-mattress-dropdown__a" target="_blank" href="${related.dataset.mattressUrl}"><img src="https:${related.dataset.image}" width="70"></a><span>${text}</span><span class="nice-mattress-dropdown__price-span">+ €${price}</span></div>`
        } else {
            if (relatedAddedPrice > 0) {
                let relatedPrice = new Intl.NumberFormat('it-IT', {maximumFractionDigits: 2}).format(relatedAddedPrice / 100)
                li.innerText = `<span class='nice-mattress-dropdown__price-span'>${li.innerText} - €${relatedPrice}</span>`
            }
        }
    }
}

let relatedNiceSelect;
let variantNiceSelect;

if (document.querySelector(".variants__select")) {
    if (isMultipleOptions) {
        for (let select of document.querySelectorAll(".multiple-variants__select")) {

            if (select.id === 'select-opt-mattress') {
                relatedNiceSelect = NiceSelect.bind(select)
                buildRelatedNiceSelect()
            } else {
                NiceSelect.bind(select)
            }
        }
    } else {
        variantNiceSelect = NiceSelect.bind(document.querySelector(".variants__select"))
    }
}

const redrawRelatedDropdown = (option_title) => {
    if (crossSellVariants !== 'undefined') {
        let crossRow = crossSellVariants.find(row => {
            if (row.option_1 === option_title) {
                return row.cross_variants
            }
        })

        relatedAddedVariant = 0
        relatedAddedPrice = 0
        let select = document.getElementById("select-opt-mattress")
        select.innerHTML = null

        let emptyOption = document.createElement("option")
        emptyOption.setAttribute("value", "empty-mattress")
        emptyOption.setAttribute("selected", "true")
        emptyOption.innerText = "Nessun materasso"
        select.appendChild(emptyOption)

        if (typeof crossRow !== 'undefined') {
            for (let row of crossRow.cross_variants) {
                let opt = document.createElement("option")
                opt.setAttribute("value", row.id)
                opt.setAttribute("data-mattress-id", row.id)
                opt.setAttribute("data-image", row.image + "&width=100")
                opt.setAttribute("data-price", row.price)
                opt.setAttribute("data-mattress-url", row.url)
                opt.innerText = row.title
                select.appendChild(opt)
            }
        }

        relatedNiceSelect.update()
        buildRelatedNiceSelect()
    }
}

if (isRelatedVariant) {
    document.getElementById("select-opt-mattress").addEventListener("change", e => {
        let select = e.currentTarget
        let variant = select.options[select.selectedIndex].value
        if (variant === "empty-mattress") {
            relatedAddedVariant = 0
            relatedAddedPrice = 0
            addToCart.setAttribute("data-related-variant","")
            buyNow.setAttribute("data-related-variant","")
        } else {
            relatedAddedVariant = parseInt(variant)
            relatedAddedPrice = parseInt(select.options[select.selectedIndex].dataset.price)
            addToCart.setAttribute("data-related-variant",variant)
            buyNow.setAttribute("data-related-variant",variant)
        }

        if (variantsSelect) {
            priceChange(variantsSelect.options[variantsSelect.selectedIndex])
        }
    })
}
//*********/ NiceSelect *********//


//********* product-variants-json *********//
let productVariants
if (document.querySelector('[data-product-variants-json]')) {
    let variantsDomSelected = document.querySelector('[data-product-variants-json]').innerHTML;
    variantsDomSelected = variantsDomSelected.replace(/[\r\n]+/g, '');
    //productVariants = JSON.parse(document.querySelector('[data-product-variants-json]').innerHTML)
  productVariants = JSON.parse(variantsDomSelected);
}
//*********/ product-variants-json *********//

//*********/ cross-sell-json *********//
let crossSellList
let crossSellVariants
if (document.querySelector('[data-cross-sell-variants-json]')) {
    let crossJsonContent = document.querySelector('[data-cross-sell-variants-json]').innerHTML
    crossJsonContent = crossJsonContent.replaceAll("},]","}]")
    crossSellVariants = JSON.parse(crossJsonContent)
}
//*********/ cross-sell-json *********//

//********* Changing the info of the product *********//
var variantIsSelected = false
const variantsSelect = document.querySelector(".variants__select")
const priceFirstPart = document.querySelector("#product-price-firstPart")
const priceSecondPart = document.querySelector("#product-price-secondPart")
const priceCompare = document.querySelector(".product-price__compare")
const priceDiscount = document.querySelector(".product-price__discount")

const productSku = document.querySelector(".product-info-top__sku")
const productBarcode = document.querySelector(".product-info-top__ean")
const productDeliveryEstimate = document.querySelector(".product-delivery-estimate")
const productCompareValue = document.querySelector("#msrp-value")

const productTitle = document.querySelector(".product-title")
const productDescriptionText = document.querySelectorAll("#product-description-p, #product-description-m")
const inventoryStatus = document.querySelector("#inventory-status")
const productBulletedListText = document.querySelector(".product-bulleted_list-block")

let selectContainer = isMultipleOptions ? $(".nice-select.multiple-variants__select") : $(".nice-select.variants__select")
let title = $(".product-variants__block > h5")

const addMultipleItems = cartDataObject => {
    let quantity = 0
    for (let x of cartDataObject) {
        quantity += x.quantity
    }

    fetch("/cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            items: cartDataObject,
        }),
    })
        .then((response) => {
            if (!response.ok) {
                if (response.status === 422) {
                    throw "Out of Stock!"
                } else if (response.status === 404) {
                    throw "Can not find variant!"
                } else {
                    throw "Something went wrong. Please reload the page!"
                }
            } else {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true
                }));
            }
            return response.json()
        })
        .then((data) => {
            console.log("/cart/add.js", data)
            document.documentElement.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                    quantity: Number(quantity)
                }
            }));
            addToCart.disabled = false
        })
        .catch((e) => {
            console.error("/cart/add.js", e)
        })
}

const priceChange = function (selectedOption) {
    let priceValue = selectedOption.dataset.variantPrice
    let priceCompareFallback = Math.round((parseFloat(priceValue.replace("€","").replace(",",".")) * 1.4) * 100) / 100
    const priceCompareValue = selectedOption.dataset.variantPriceCompare
    const priceDiscountValue = selectedOption.dataset.variantPriceDiscount
    const priceWithoutCurrency = selectedOption.dataset.variantPriceWcurrency
    let priceInt = parseInt(selectedOption.dataset.variantPriceInt)

    if (isRelatedVariant && relatedAddedPrice > 0 && relatedAddedVariant > 0) {
        priceInt += relatedAddedPrice
        priceValue = new Intl.NumberFormat('it-IT', {maximumFractionDigits: 2}).format(priceInt/100)
        priceValue = priceValue.toString()
    }

    const priceArr = priceValue.split(",")
    priceFirstPart.textContent = `${priceArr[0]},`
    priceSecondPart.textContent = `${priceArr[1]}`
    priceCompare.textContent = `${priceCompareValue}`
    
    if (productCompareValue) {
        if (selectedOption.dataset.variantPriceCompare !== '') {
            productCompareValue.textContent = (priceCompareValue.indexOf('€') > -1 ? '' : 'priceCompareFallback') + ' ' + priceCompareValue
        } else {
            productCompareValue.textContent = (priceCompareFallback.indexOf('€') > -1 ? '' : '€') + ' ' + priceCompareFallback
        }
    }

    const discountLabel = document.querySelector('.discount-label');
    if (discountLabel) {
        const variantPriceInt = parseInt(selectedOption.dataset.variantPriceInt)
        const variantCompareInt = parseInt(selectedOption.dataset.variantPriceCompareInt);
        if (variantCompareInt > variantPriceInt) {
            const discountAmount = (((variantCompareInt - variantPriceInt) / variantCompareInt) * 100).toFixed();
            discountLabel.innerText = discountAmount + '% di sconto';
            discountLabel.style.display = 'block';
        } else {
            discountLabel.innerText = '';
            discountLabel.style.display = 'none';
        }
    }
  
    priceDiscount.textContent = `Risparmi ${priceDiscountValue}!`
    buyNowId.dataset.variantPrice = priceWithoutCurrency
  if (document.getElementById("heidipay-container") !== null && priceInt > 8000) {
    document.getElementById("heidipay-container").setAttribute("data-heidipay-minorAmount", priceInt);
  }
    document.getElementById("scalapay_price").innerText = priceValue
    document.querySelector("klarna-placement").dataset.purchaseAmount = String(priceInt)
    document.querySelector("[data-pp-message]").dataset.ppAmount = String(priceInt/100)
}

const infoChange = function (selectedOption) {
    const skuValue = selectedOption.dataset.variantSku
    const barcodeValue = selectedOption.dataset.variantBarcode

    productSku.textContent = `Cod: ${skuValue}`
    productBarcode.textContent = `Ean: ${barcodeValue}`

}

const vipPointsChange = function (selectedOption) {
    const price = selectedOption.dataset.variantPriceWcurrency;
    vipPoints.innerHTML = '<strong>' + (Number(price) * 20).toFixed() + '</strong>';
}

const descriptionChange = function (selectedOption) {
    // const currentId = selectedOption.value

    // const currentVariant = productVariants.find(function (variant) {
    //   if (variant.id == currentId) return variant
    // })

    if (currentVariant.title && currentVariant.title !== 'null') {
        productTitle.textContent = `${currentVariant.title}`
        buyNowId.dataset.productName = currentVariant.title
    }
    if (currentVariant.bulleted_list && currentVariant.bulleted_list !== 'null') {
        productBulletedListText.innerHTML = currentVariant.bulleted_list
    }

    if (currentVariant.description && currentVariant.description !== 'null') {
        productDescriptionText.forEach(text => {
            text.innerHTML = currentVariant.description
        });
    }

}

const updateAddToCard = function (selectedOption) {
    addToCart.dataset.productId = selectedOption.value
    buyNow.dataset.productId = selectedOption.value
}

const searchCrossSell = (variantId) => {
    let crossContainer = document.querySelector(".cross_bed--container")
    crossContainer.innerHTML = ""

    crossSellList = crossSellVariants.find(row => {
        if (row.variant_id == variantId) {
            return row.cross_variants
        }
    })
}

const changeCrossSell = () => {
    let originalPrice = Number(crossSellList.original_price)
    let originalPriceMoney = new Intl.NumberFormat('it-IT', {maximumFractionDigits: 2}).format(originalPrice/100)
    let crossContainer = document.querySelector(".cross_bed--container")
    crossContainer.innerHTML = ""


    for (let crossItem of crossSellList.cross_variants) {
        let totalPrice = Number(originalPrice + crossItem.price)
        let totalPriceMoney = new Intl.NumberFormat('it-IT', {maximumFractionDigits: 2}).format(totalPrice/100)
        let crossPriceMoney = new Intl.NumberFormat('it-IT', {maximumFractionDigits: 2}).format(crossItem.price/100)

        crossContainer.innerHTML += `
            <div class="cross_bed--item">
                <div class="item-cross-bed__row">
                    <div class="item-cross-bed__item original-item">
                        <img src="${crossSellList.original_image}" alt="${crossSellList.original_title}" width="150" height="150" class="cross-sell-thumb">
                    </div>
                    <div class="item-cross-bed__item cross-plus-span"><strong>+</strong></div>
                    <div class="item-cross-bed__item cross-item">
                        <a href="${crossItem.url}" target="_blank">
                            <img src="${crossItem.image}" alt="${crossItem.title}" width="150" height="150" class="cross-sell-thumb">
                        </a>
                    </div>
        
                    <div class="item-cross-bed__item item-cross-bed__item-prices">
                        <div class="item-prices__text">
                            <p>Prezzo totale: €${totalPriceMoney}</p>
                        </div>
                        <div class="item-prices__button">
                            <button type="button" class="cross_bed--buttons" data-original-variant="${crossSellList.variant_id}" data-cross-id="${crossItem.id}" data-total-price="${totalPrice}">Aggiungi questi prodotti al carrello</button>
                        </div>
                    </div>
                </div>
                <div class="item-cross-bed__text">
                    <p>${crossSellList.original_title}: <strong>€${originalPriceMoney}</strong></p>
                    <p><a href="${crossItem.url}" target="_blank" rel="noopener">${crossItem.title}: <strong>€${crossPriceMoney}</strong></a></p>
                </div>
            </div>`;
        document.querySelector(`[data-cross-id='${crossItem.id}']`).addEventListener("click", e => {
            addMultipleItems([
                {
                    id: Number(e.currentTarget.dataset.originalVariant),
                    quantity: 1
                },
                {
                    id: Number(e.currentTarget.dataset.crossId),
                    quantity: 1
                }
            ])
        })
    }
}

//*********/ Changing the info of the product *********//

//********* Product inventory *********//

const checkInventory = function (variant) {
    if (!variant) {
        const inventory = Number(buyNowQuantity.dataset.productAvailable)
        toggleStateButtons(inventory)
    } else {
        const inventory = Number(variant.dataset.variantAvailable)
        toggleStateButtons(inventory)
        if (inventory) {
            inventoryStatus.textContent = "Disponibile"
            inventoryStatus.classList.remove("product-info__unavailable")
            inventoryStatus.classList.add("product-info__available")
        } else {
            inventoryStatus.textContent = "Esaurito"
            inventoryStatus.classList.remove("product-info__available")
            inventoryStatus.classList.add("product-info__unavailable")
        }
    }
}

//*********/ Product inventory *********//


const hideFakeOption = (selector) => {
    let emptyVal = selector.querySelectorAll('[value="empty"]')
    if (emptyVal.length > 0) {
        selector.removeChild(emptyVal[0])
    }

    let li = document.querySelectorAll('[data-value="empty"]')
    if (li.length > 0) {
        li[0].remove()
    }
}

//*********/ Estimated delivery time for the product *********//

const shippingCalculation = () => {
    const leadtime = currentVariant.ship_from_mc ? 1 : parseFloat(currentVariant.leadtime)
    const closingDate = new Date(currentVariant.closingDate)
    const openingDate = new Date(currentVariant.openingDate)

    const italianHolidays = [{month: "gennaio", day: 1}, {month: "gennaio", day: 6}, {
        month: "agosto",
        day: 15
    }, {month: "novembre", day: 1}, {month: "dicembre", day: 8}, {month: "dicembre", day: 25}, {
        month: "dicembre",
        day: 26
    }, {month: "aprile", day: 25}, {month: "maggio", day: 1}, {month: "giugno", day: 2}]

    const months = ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"]
    const days = ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"]

    const isSaturday = (date) => {
        return days[date.getDay()] === "sabato"
    }

    const isSunday = (date) => {
        return days[date.getDay()] === "domenica"
    }

    const isClosed = (date) => {
        return date >= closingDate && date <= openingDate
    }

    const isHoliday = (date) => {
        for (let holiday of italianHolidays) {
            if (months[date.getMonth()] === holiday.month) {
                if (date.getDate() === holiday.day) {
                    return true
                }
            }
        }
        return false
    }

    const dateValidator = (date) => {
        return !isHoliday(date)
            && !isSaturday(date)
            && !isSunday(date);
    }

    const calculateEtd = (start_date, leadtime, isFirstDay) => {
        let addDays = new Date(start_date)
        if (isFirstDay) {
            if (isClosed(addDays)) {
                addDays = openingDate
            }
        }
        for (let i = 1; i <= leadtime; i++) {
            addDays.setDate(addDays.getDate() + 1)
            while (!dateValidator(addDays)) {
                addDays.setDate(addDays.getDate() + 1)
            }
        }
        return addDays
    }

    const today = new Date()
    const deliveryTime = currentVariant.carrier === 'FERCAM' ? leadtime + 4 : leadtime + 1
    const startDay = calculateEtd(today, deliveryTime, true)
    const endDay = calculateEtd(startDay, 1, false)

    productDeliveryEstimate.textContent = `${days[startDay.getDay()]} ${startDay.getDate()} ${months[(startDay.getMonth())]} e ${days[endDay.getDay()]} ${endDay.getDate()} ${months[(endDay.getMonth())]}`

    const deliveryBadgeCol = document.querySelectorAll(".product-delivery__date-limit")
    if (deliveryBadgeCol.length > 0) {
        const deliveryBadge = deliveryBadgeCol[0]
        const dateLimit = new Date(deliveryBadge.dataset.deliveryDateLimit)
        if (endDay < dateLimit) {
            deliveryBadge.style.display = "block"
        } else {
            deliveryBadge.style.display = "none"
        }
    }
}

const applyBestSellerLabel = () => {
    let productLabelList = document.querySelector('.product-item__label-list')
    if (productLabelList) {
        productLabelList.innerHTML = '';
        productLabelList.innerHTML = '<span class="product-label product-label--custom3">ULTIMI PEZZI!</span>'
    }
}

const checkIsBestSeller = (variantId) => {
    const productSearchParams = new URLSearchParams(window.location.search)
    if (productSearchParams.size > 0) {
        if (productSearchParams.get('is_bs') == 1) {
            applyBestSellerLabel();   
        }
    } else {
        Clerk("call", 
            "product/attributes",
            {
                key: "04knoslqXwkehKHGMcbT5mOoiApQKFpE",
                products: [variantId],
                attributes: ["is_bestseller"]
            },
            function(response){ 
                if (response.length) {
                    if (response[0] && response[0].is_bestseller) {
                        applyBestSellerLabel();
                    }
                }
            },
            function(response){ 
                console.error(response); 
            }
        );
    }
}

//********* search for the current variant *********//

const searchCurrentVariant = function (variantId) {
    currentVariant = productVariants.find(function (variant) {
        if (variant.id == variantId) return variant
    })
}

//********* search for the current variant *********//

//********* changing variant info *********//
if (variantsSelect) {
    variantsSelect.addEventListener("change", function () {
        const selectedOption = variantsSelect.options[variantsSelect.selectedIndex]
        if (!variantIsSelected) {
            let selector = document.getElementById("main-variant-select")
            hideFakeOption(selector)
        }

        $(selectContainer).css("border", "none")
        $(title).css("color", "#5c646c")
        if (!isMultipleOptions) {
            $(".select-title__false").removeClass("select-title__false").addClass("select-title__true")
        }

        buyNowId.value = selectedOption.value
        searchCurrentVariant(selectedOption.value)
        priceChange(selectedOption)
        infoChange(selectedOption)
        descriptionChange(selectedOption)
        vipPointsChange(selectedOption)

        if (selectedOption.dataset.variantAvailable === "1") {
            $(".product-delivery__block").show()
            $(".btn-available-target").show()
            shippingCalculation(selectedOption.value)

        } else {
            $(".product-delivery__block").hide()
            $(".btn-available-target").hide()
        }

        if (crossSellVariants) {
            searchCrossSell(selectedOption.value)
            if (typeof crossSellList !== 'undefined') {
                if (crossSellList.cross_variants.length > 0) {
                    changeCrossSell()
                }
            }
        }

        updateAddToCard(selectedOption)
        checkInventory(selectedOption)
        variantIsSelected = true
    })
} else {
    variantIsSelected = true
}

if (isMultipleOptions) {
    //product with multiple selectors

    let firstOptionSelected = false
    let secondOptionSelected = false
    let selectedOptions = {
        first: null,
        second: null
    }

    const checkMultipleSelection = () => {
        if (firstOptionSelected && secondOptionSelected) {
            let optionToSelect = variantsSelect.querySelector('[data-option-1="' + selectedOptions.first + '"][data-option-2="' + selectedOptions.second + '"]')
            optionToSelect.selected = true
            variantsSelect.dispatchEvent(new Event("change"))
        }
        return true
    }

    const select_opt1 = document.querySelector(".select-opt-1")
    const select_opt2 = document.querySelector(".select-opt-2")

    select_opt1.addEventListener("change", () => {
        firstOptionSelected = true
        let option_title = select_opt1.options[select_opt1.selectedIndex].value
        selectedOptions.first = option_title
        $(".select-title-1").removeClass("select-title__false").addClass("select-title__true")
        if (isRelatedVariant) {
            redrawRelatedDropdown(option_title)
        }
        hideFakeOption(select_opt1)
        checkMultipleSelection()
    })

    select_opt2.addEventListener("change", () => {
        secondOptionSelected = true
        selectedOptions.second = select_opt2.options[select_opt2.selectedIndex].value
        $(".select-title-2").removeClass("select-title__false").addClass("select-title__true")
        hideFakeOption(select_opt2)
        checkMultipleSelection()
    })
}

//*********/ changing variant info *********//

const selectVariantByParam = () => {
    const variantSearchParams = new URLSearchParams(window.location.search);
    const variantParam = variantSearchParams.get('v')
    if (variantParam) {
        const niceSelectOptions = document.querySelector('.nice-select-dropdown')
        if(niceSelectOptions) {
            const niceSelecteOptionToSelect = niceSelectOptions.querySelector('li[data-value="' + variantParam + '"]')
            if (niceSelecteOptionToSelect) {
                niceSelecteOptionToSelect.click()
                niceSelecteOptionToSelect.click()
            }
        }
    }
}

//********* init *********//

(function init() {
    if (buyNowId) {
        checkIsBestSeller(buyNowId.value)
        searchCurrentVariant(buyNowId.value)
        checkInventory()
        shippingCalculation(buyNowId.value)
        variantIsSelected = buyNowId.dataset.hasOnlyDefaultVariant === "true"
        selectVariantByParam()
    }
})()

//*********/ init *********//
